import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getRegions } from "common/services/regions.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectRegion = ({
  validation,
  isUpdate,
  selectedId,
}: {
  validation: any;
  isUpdate?: boolean;
  selectedId?: number;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.regions && validation.errors.regions
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.regions && validation.errors.regions
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters = {};
        if (isUpdate) {
          filters = {
            regions: selectedId,
          };
        }
        const response = await getRegions({
          pagination: {
            page: 1,
            pageSize: 20,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [isUpdate, selectedId]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="regions-field" className="form-label">
        Location
      </Label>
      <Select
        name="regions"
        id="regions"
        value={validation.values.regions ? validation.values.regions : null}
        isMulti
        placeholder="Select location(s)"
        validate={{
          required: { value: true },
        }}
        onChange={(value: any) => {
          validation.setFieldValue("regions", value);
          validation.setFieldError("regions", "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getRegions({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  name: {
                    $containsi: inputValue,
                  },
                },
              ],
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.name}`,
                };
              })
            );
          });
        }}
        onBlur={() => validation.setFieldTouched("regions", true)}
        className={
          validation.touched.regions && validation.errors.regions
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors.regions?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectRegion;
